const initialState = {
  uploadError: {},
  loading: false,
  imsActionResponse: {},
};

const imsActions = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'IMS_ACTIONS_UPDATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'IMS_ACTIONS_UPDATE_SUCCESS':
      return {
        ...state,
        loading: false,
        imsActionResponse: payload,
        uploadError: '',
      };
    case 'IMS_ACTIONS_UPDATE_FAILURE':
      return {
        ...state,
        imsActionResponse: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default imsActions;



// WEBPACK FOOTER //
// ./client/app/reducers/ims_actions.js